"use strict";

import React from "react";

function FormFieldLabel(props) {
  let { element, onClick } = props;
  let label = element.getIn(["form", "label"], "No Label");

  let style = {
    height: 25,
    padding: 5,
    lineHeight: "15px",
    whiteSpace: "nowrap",
  };

  return (
    <div style={style} onClick={onClick}>
      Form Input: <span style={{ cursor: "pointer" }}>{label}</span>
    </div>
  );
}

export default FormFieldLabel;
